// ⚠️ This file can be auto-generated. Run `npm run gwi` to regenerate it.

import { GlobalWordingMap } from '@/types';

import { ASTROLOGY_WORDING_BA } from './astrology/ASTROLOGY_WORDING_BA';
import { ASTROLOGY_WORDING_BG } from './astrology/ASTROLOGY_WORDING_BG';
import { ASTROLOGY_WORDING_DE } from './astrology/ASTROLOGY_WORDING_DE';
import { ASTROLOGY_WORDING_EE } from './astrology/ASTROLOGY_WORDING_EE';
import { ASTROLOGY_WORDING_EN } from './astrology/ASTROLOGY_WORDING_EN';
import { ASTROLOGY_WORDING_FI } from './astrology/ASTROLOGY_WORDING_FI';
import { ASTROLOGY_WORDING_FR } from './astrology/ASTROLOGY_WORDING_FR';
import { ASTROLOGY_WORDING_HR } from './astrology/ASTROLOGY_WORDING_HR';
import { ASTROLOGY_WORDING_LT } from './astrology/ASTROLOGY_WORDING_LT';
import { ASTROLOGY_WORDING_LV } from './astrology/ASTROLOGY_WORDING_LV';
import { ASTROLOGY_WORDING_NO } from './astrology/ASTROLOGY_WORDING_NO';
import { ASTROLOGY_WORDING_PL } from './astrology/ASTROLOGY_WORDING_PL';
import { ASTROLOGY_WORDING_RO } from './astrology/ASTROLOGY_WORDING_RO';
import { ASTROLOGY_WORDING_RS } from './astrology/ASTROLOGY_WORDING_RS';
import { ASTROLOGY_WORDING_SK } from './astrology/ASTROLOGY_WORDING_SK';
import { COOKING_WORDING_BG } from './cooking/COOKING_WORDING_BG';
import { COOKING_WORDING_CY } from './cooking/COOKING_WORDING_CY';
import { COOKING_WORDING_CZ } from './cooking/COOKING_WORDING_CZ';
import { COOKING_WORDING_DE } from './cooking/COOKING_WORDING_DE';
import { COOKING_WORDING_DK } from './cooking/COOKING_WORDING_DK';
import { COOKING_WORDING_EE } from './cooking/COOKING_WORDING_EE';
import { COOKING_WORDING_EN } from './cooking/COOKING_WORDING_EN';
import { COOKING_WORDING_FI } from './cooking/COOKING_WORDING_FI';
import { COOKING_WORDING_FR } from './cooking/COOKING_WORDING_FR';
import { COOKING_WORDING_HR } from './cooking/COOKING_WORDING_HR';
import { COOKING_WORDING_LT } from './cooking/COOKING_WORDING_LT';
import { COOKING_WORDING_LV } from './cooking/COOKING_WORDING_LV';
import { COOKING_WORDING_NO } from './cooking/COOKING_WORDING_NO';
import { COOKING_WORDING_PL } from './cooking/COOKING_WORDING_PL';
import { COOKING_WORDING_RO } from './cooking/COOKING_WORDING_RO';
import { COOKING_WORDING_RS } from './cooking/COOKING_WORDING_RS';
import { COOKING_WORDING_SE } from './cooking/COOKING_WORDING_SE';
import { COOKING_WORDING_SI } from './cooking/COOKING_WORDING_SI';
import { COOKING_WORDING_SK } from './cooking/COOKING_WORDING_SK';
import { FITNESS_WORDING_BA } from './fitness/FITNESS_WORDING_BA';
import { FITNESS_WORDING_BG } from './fitness/FITNESS_WORDING_BG';
import { FITNESS_WORDING_CY } from './fitness/FITNESS_WORDING_CY';
import { FITNESS_WORDING_CZ } from './fitness/FITNESS_WORDING_CZ';
import { FITNESS_WORDING_DE } from './fitness/FITNESS_WORDING_DE';
import { FITNESS_WORDING_DK } from './fitness/FITNESS_WORDING_DK';
import { FITNESS_WORDING_EE } from './fitness/FITNESS_WORDING_EE';
import { FITNESS_WORDING_EN } from './fitness/FITNESS_WORDING_EN';
import { FITNESS_WORDING_FI } from './fitness/FITNESS_WORDING_FI';
import { FITNESS_WORDING_FR } from './fitness/FITNESS_WORDING_FR';
import { FITNESS_WORDING_HR } from './fitness/FITNESS_WORDING_HR';
import { FITNESS_WORDING_LT } from './fitness/FITNESS_WORDING_LT';
import { FITNESS_WORDING_LV } from './fitness/FITNESS_WORDING_LV';
import { FITNESS_WORDING_NO } from './fitness/FITNESS_WORDING_NO';
import { FITNESS_WORDING_PL } from './fitness/FITNESS_WORDING_PL';
import { FITNESS_WORDING_RO } from './fitness/FITNESS_WORDING_RO';
import { FITNESS_WORDING_RS } from './fitness/FITNESS_WORDING_RS';
import { FITNESS_WORDING_SE } from './fitness/FITNESS_WORDING_SE';
import { FITNESS_WORDING_SI } from './fitness/FITNESS_WORDING_SI';
import { FITNESS_WORDING_SK } from './fitness/FITNESS_WORDING_SK';
import { LOVE_WORDING_BA } from './love/LOVE_WORDING_BA';
import { LOVE_WORDING_BG } from './love/LOVE_WORDING_BG';
import { LOVE_WORDING_DE } from './love/LOVE_WORDING_DE';
import { LOVE_WORDING_EE } from './love/LOVE_WORDING_EE';
import { LOVE_WORDING_EN } from './love/LOVE_WORDING_EN';
import { LOVE_WORDING_FI } from './love/LOVE_WORDING_FI';
import { LOVE_WORDING_FR } from './love/LOVE_WORDING_FR';
import { LOVE_WORDING_LT } from './love/LOVE_WORDING_LT';
import { LOVE_WORDING_LV } from './love/LOVE_WORDING_LV';
import { LOVE_WORDING_NO } from './love/LOVE_WORDING_NO';
import { LOVE_WORDING_PL } from './love/LOVE_WORDING_PL';
import { LOVE_WORDING_RO } from './love/LOVE_WORDING_RO';
import { LOVE_WORDING_RS } from './love/LOVE_WORDING_RS';
import { LOVE_WORDING_SK } from './love/LOVE_WORDING_SK';
import { MEDITATION_WORDING_BG } from './meditation/MEDITATION_WORDING_BG';
import { MEDITATION_WORDING_DE } from './meditation/MEDITATION_WORDING_DE';
import { MEDITATION_WORDING_EE } from './meditation/MEDITATION_WORDING_EE';
import { MEDITATION_WORDING_EN } from './meditation/MEDITATION_WORDING_EN';
import { MEDITATION_WORDING_FI } from './meditation/MEDITATION_WORDING_FI';
import { MEDITATION_WORDING_FR } from './meditation/MEDITATION_WORDING_FR';
import { MEDITATION_WORDING_LT } from './meditation/MEDITATION_WORDING_LT';
import { MEDITATION_WORDING_LV } from './meditation/MEDITATION_WORDING_LV';
import { MEDITATION_WORDING_NO } from './meditation/MEDITATION_WORDING_NO';
import { MEDITATION_WORDING_PL } from './meditation/MEDITATION_WORDING_PL';
import { MEDITATION_WORDING_RO } from './meditation/MEDITATION_WORDING_RO';
import { MEDITATION_WORDING_RS } from './meditation/MEDITATION_WORDING_RS';
import { MEDITATION_WORDING_SK } from './meditation/MEDITATION_WORDING_SK';
import { PILATES_WORDING_BA } from './pilates/PILATES_WORDING_BA';
import { PILATES_WORDING_BG } from './pilates/PILATES_WORDING_BG';
import { PILATES_WORDING_CY } from './pilates/PILATES_WORDING_CY';
import { PILATES_WORDING_CZ } from './pilates/PILATES_WORDING_CZ';
import { PILATES_WORDING_DE } from './pilates/PILATES_WORDING_DE';
import { PILATES_WORDING_DK } from './pilates/PILATES_WORDING_DK';
import { PILATES_WORDING_EE } from './pilates/PILATES_WORDING_EE';
import { PILATES_WORDING_EN } from './pilates/PILATES_WORDING_EN';
import { PILATES_WORDING_FI } from './pilates/PILATES_WORDING_FI';
import { PILATES_WORDING_FR } from './pilates/PILATES_WORDING_FR';
import { PILATES_WORDING_HR } from './pilates/PILATES_WORDING_HR';
import { PILATES_WORDING_LT } from './pilates/PILATES_WORDING_LT';
import { PILATES_WORDING_LV } from './pilates/PILATES_WORDING_LV';
import { PILATES_WORDING_NO } from './pilates/PILATES_WORDING_NO';
import { PILATES_WORDING_PL } from './pilates/PILATES_WORDING_PL';
import { PILATES_WORDING_RO } from './pilates/PILATES_WORDING_RO';
import { PILATES_WORDING_RS } from './pilates/PILATES_WORDING_RS';
import { PILATES_WORDING_SE } from './pilates/PILATES_WORDING_SE';
import { PILATES_WORDING_SI } from './pilates/PILATES_WORDING_SI';
import { PILATES_WORDING_SK } from './pilates/PILATES_WORDING_SK';
import { YOGA_WORDING_BA } from './yoga/YOGA_WORDING_BA';
import { YOGA_WORDING_BG } from './yoga/YOGA_WORDING_BG';
import { YOGA_WORDING_CY } from './yoga/YOGA_WORDING_CY';
import { YOGA_WORDING_CZ } from './yoga/YOGA_WORDING_CZ';
import { YOGA_WORDING_DE } from './yoga/YOGA_WORDING_DE';
import { YOGA_WORDING_DK } from './yoga/YOGA_WORDING_DK';
import { YOGA_WORDING_EE } from './yoga/YOGA_WORDING_EE';
import { YOGA_WORDING_EN } from './yoga/YOGA_WORDING_EN';
import { YOGA_WORDING_FI } from './yoga/YOGA_WORDING_FI';
import { YOGA_WORDING_FR } from './yoga/YOGA_WORDING_FR';
import { YOGA_WORDING_HR } from './yoga/YOGA_WORDING_HR';
import { YOGA_WORDING_LT } from './yoga/YOGA_WORDING_LT';
import { YOGA_WORDING_LV } from './yoga/YOGA_WORDING_LV';
import { YOGA_WORDING_NO } from './yoga/YOGA_WORDING_NO';
import { YOGA_WORDING_PL } from './yoga/YOGA_WORDING_PL';
import { YOGA_WORDING_RO } from './yoga/YOGA_WORDING_RO';
import { YOGA_WORDING_RS } from './yoga/YOGA_WORDING_RS';
import { YOGA_WORDING_SE } from './yoga/YOGA_WORDING_SE';
import { YOGA_WORDING_SI } from './yoga/YOGA_WORDING_SI';
import { YOGA_WORDING_SK } from './yoga/YOGA_WORDING_SK';
import { MULTI_FITNESS_YOGA_PILATES_WORDING_BA } from './multiFitnessYogaPilates/MULTI_FITNESS_YOGA_PILATES_WORDING_BA';
import { MULTI_FITNESS_YOGA_PILATES_WORDING_BG } from './multiFitnessYogaPilates/MULTI_FITNESS_YOGA_PILATES_WORDING_BG';
import { MULTI_FITNESS_YOGA_PILATES_WORDING_CZ } from './multiFitnessYogaPilates/MULTI_FITNESS_YOGA_PILATES_WORDING_CZ';
import { MULTI_FITNESS_YOGA_PILATES_WORDING_DE } from './multiFitnessYogaPilates/MULTI_FITNESS_YOGA_PILATES_WORDING_DE';
import { MULTI_FITNESS_YOGA_PILATES_WORDING_DK } from './multiFitnessYogaPilates/MULTI_FITNESS_YOGA_PILATES_WORDING_DK';
import { MULTI_FITNESS_YOGA_PILATES_WORDING_EE } from './multiFitnessYogaPilates/MULTI_FITNESS_YOGA_PILATES_WORDING_EE';
import { MULTI_FITNESS_YOGA_PILATES_WORDING_EN } from './multiFitnessYogaPilates/MULTI_FITNESS_YOGA_PILATES_WORDING_EN';
import { MULTI_FITNESS_YOGA_PILATES_WORDING_FI } from './multiFitnessYogaPilates/MULTI_FITNESS_YOGA_PILATES_WORDING_FI';
import { MULTI_FITNESS_YOGA_PILATES_WORDING_FR } from './multiFitnessYogaPilates/MULTI_FITNESS_YOGA_PILATES_WORDING_FR';
import { MULTI_FITNESS_YOGA_PILATES_WORDING_HR } from './multiFitnessYogaPilates/MULTI_FITNESS_YOGA_PILATES_WORDING_HR';
import { MULTI_FITNESS_YOGA_PILATES_WORDING_LT } from './multiFitnessYogaPilates/MULTI_FITNESS_YOGA_PILATES_WORDING_LT';
import { MULTI_FITNESS_YOGA_PILATES_WORDING_LV } from './multiFitnessYogaPilates/MULTI_FITNESS_YOGA_PILATES_WORDING_LV';
import { MULTI_FITNESS_YOGA_PILATES_WORDING_NO } from './multiFitnessYogaPilates/MULTI_FITNESS_YOGA_PILATES_WORDING_NO';
import { MULTI_FITNESS_YOGA_PILATES_WORDING_PL } from './multiFitnessYogaPilates/MULTI_FITNESS_YOGA_PILATES_WORDING_PL';
import { MULTI_FITNESS_YOGA_PILATES_WORDING_RO } from './multiFitnessYogaPilates/MULTI_FITNESS_YOGA_PILATES_WORDING_RO';
import { MULTI_FITNESS_YOGA_PILATES_WORDING_RS } from './multiFitnessYogaPilates/MULTI_FITNESS_YOGA_PILATES_WORDING_RS';
import { MULTI_FITNESS_YOGA_PILATES_WORDING_SE } from './multiFitnessYogaPilates/MULTI_FITNESS_YOGA_PILATES_WORDING_SE';
import { MULTI_FITNESS_YOGA_PILATES_WORDING_SI } from './multiFitnessYogaPilates/MULTI_FITNESS_YOGA_PILATES_WORDING_SI';
import { MULTI_FITNESS_YOGA_PILATES_WORDING_SK } from './multiFitnessYogaPilates/MULTI_FITNESS_YOGA_PILATES_WORDING_SK';
import { MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_BA } from './multiAstrologyMeditationLove/MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_BA';
import { MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_BG } from './multiAstrologyMeditationLove/MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_BG';
import { MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_CZ } from './multiAstrologyMeditationLove/MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_CZ';
import { MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_DE } from './multiAstrologyMeditationLove/MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_DE';
import { MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_DK } from './multiAstrologyMeditationLove/MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_DK';
import { MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_EE } from './multiAstrologyMeditationLove/MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_EE';
import { MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_EN } from './multiAstrologyMeditationLove/MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_EN';
import { MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_FI } from './multiAstrologyMeditationLove/MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_FI';
import { MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_FR } from './multiAstrologyMeditationLove/MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_FR';
import { MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_HR } from './multiAstrologyMeditationLove/MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_HR';
import { MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_LT } from './multiAstrologyMeditationLove/MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_LT';
import { MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_LV } from './multiAstrologyMeditationLove/MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_LV';
import { MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_NO } from './multiAstrologyMeditationLove/MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_NO';
import { MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_PL } from './multiAstrologyMeditationLove/MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_PL';
import { MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_RO } from './multiAstrologyMeditationLove/MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_RO';
import { MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_SE } from './multiAstrologyMeditationLove/MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_SE';
import { MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_SI } from './multiAstrologyMeditationLove/MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_SI';
import { MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_SK } from './multiAstrologyMeditationLove/MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_SK';

const WORDING = {
  astrology: {
    BA: ASTROLOGY_WORDING_BA,
    BG: ASTROLOGY_WORDING_BG,
    DE: ASTROLOGY_WORDING_DE,
    EE: ASTROLOGY_WORDING_EE,
    EN: ASTROLOGY_WORDING_EN,
    FI: ASTROLOGY_WORDING_FI,
    FR: ASTROLOGY_WORDING_FR,
    HR: ASTROLOGY_WORDING_HR,
    LT: ASTROLOGY_WORDING_LT,
    LV: ASTROLOGY_WORDING_LV,
    NO: ASTROLOGY_WORDING_NO,
    PL: ASTROLOGY_WORDING_PL,
    RO: ASTROLOGY_WORDING_RO,
    RS: ASTROLOGY_WORDING_RS,
    SK: ASTROLOGY_WORDING_SK,
  },
  cooking: {
    BG: COOKING_WORDING_BG,
    CY: COOKING_WORDING_CY,
    CZ: COOKING_WORDING_CZ,
    DE: COOKING_WORDING_DE,
    DK: COOKING_WORDING_DK,
    EE: COOKING_WORDING_EE,
    EN: COOKING_WORDING_EN,
    FI: COOKING_WORDING_FI,
    FR: COOKING_WORDING_FR,
    HR: COOKING_WORDING_HR,
    LT: COOKING_WORDING_LT,
    LV: COOKING_WORDING_LV,
    NO: COOKING_WORDING_NO,
    PL: COOKING_WORDING_PL,
    RO: COOKING_WORDING_RO,
    RS: COOKING_WORDING_RS,
    SE: COOKING_WORDING_SE,
    SI: COOKING_WORDING_SI,
    SK: COOKING_WORDING_SK,
  },
  fitness: {
    BA: FITNESS_WORDING_BA,
    BG: FITNESS_WORDING_BG,
    CY: FITNESS_WORDING_CY,
    CZ: FITNESS_WORDING_CZ,
    DE: FITNESS_WORDING_DE,
    DK: FITNESS_WORDING_DK,
    EE: FITNESS_WORDING_EE,
    EN: FITNESS_WORDING_EN,
    FI: FITNESS_WORDING_FI,
    FR: FITNESS_WORDING_FR,
    HR: FITNESS_WORDING_HR,
    LT: FITNESS_WORDING_LT,
    LV: FITNESS_WORDING_LV,
    NO: FITNESS_WORDING_NO,
    PL: FITNESS_WORDING_PL,
    RO: FITNESS_WORDING_RO,
    RS: FITNESS_WORDING_RS,
    SE: FITNESS_WORDING_SE,
    SI: FITNESS_WORDING_SI,
    SK: FITNESS_WORDING_SK,
  },
  love: {
    BA: LOVE_WORDING_BA,
    BG: LOVE_WORDING_BG,
    DE: LOVE_WORDING_DE,
    EE: LOVE_WORDING_EE,
    EN: LOVE_WORDING_EN,
    FI: LOVE_WORDING_FI,
    FR: LOVE_WORDING_FR,
    LT: LOVE_WORDING_LT,
    LV: LOVE_WORDING_LV,
    NO: LOVE_WORDING_NO,
    PL: LOVE_WORDING_PL,
    RO: LOVE_WORDING_RO,
    RS: LOVE_WORDING_RS,
    SK: LOVE_WORDING_SK,
  },
  meditation: {
    BG: MEDITATION_WORDING_BG,
    DE: MEDITATION_WORDING_DE,
    EE: MEDITATION_WORDING_EE,
    EN: MEDITATION_WORDING_EN,
    FI: MEDITATION_WORDING_FI,
    FR: MEDITATION_WORDING_FR,
    LT: MEDITATION_WORDING_LT,
    LV: MEDITATION_WORDING_LV,
    NO: MEDITATION_WORDING_NO,
    PL: MEDITATION_WORDING_PL,
    RO: MEDITATION_WORDING_RO,
    RS: MEDITATION_WORDING_RS,
    SK: MEDITATION_WORDING_SK,
  },
  pilates: {
    BA: PILATES_WORDING_BA,
    BG: PILATES_WORDING_BG,
    CY: PILATES_WORDING_CY,
    CZ: PILATES_WORDING_CZ,
    DE: PILATES_WORDING_DE,
    DK: PILATES_WORDING_DK,
    EE: PILATES_WORDING_EE,
    EN: PILATES_WORDING_EN,
    FI: PILATES_WORDING_FI,
    FR: PILATES_WORDING_FR,
    HR: PILATES_WORDING_HR,
    LT: PILATES_WORDING_LT,
    LV: PILATES_WORDING_LV,
    NO: PILATES_WORDING_NO,
    PL: PILATES_WORDING_PL,
    RO: PILATES_WORDING_RO,
    RS: PILATES_WORDING_RS,
    SE: PILATES_WORDING_SE,
    SI: PILATES_WORDING_SI,
    SK: PILATES_WORDING_SK,
  },
  yoga: {
    BA: YOGA_WORDING_BA,
    BG: YOGA_WORDING_BG,
    CY: YOGA_WORDING_CY,
    CZ: YOGA_WORDING_CZ,
    DE: YOGA_WORDING_DE,
    DK: YOGA_WORDING_DK,
    EE: YOGA_WORDING_EE,
    EN: YOGA_WORDING_EN,
    FI: YOGA_WORDING_FI,
    FR: YOGA_WORDING_FR,
    HR: YOGA_WORDING_HR,
    LT: YOGA_WORDING_LT,
    LV: YOGA_WORDING_LV,
    NO: YOGA_WORDING_NO,
    PL: YOGA_WORDING_PL,
    RO: YOGA_WORDING_RO,
    RS: YOGA_WORDING_RS,
    SE: YOGA_WORDING_SE,
    SI: YOGA_WORDING_SI,
    SK: YOGA_WORDING_SK,
  },
  multiFitnessYogaPilates: {
    BA: MULTI_FITNESS_YOGA_PILATES_WORDING_BA,
    BG: MULTI_FITNESS_YOGA_PILATES_WORDING_BG,
    CZ: MULTI_FITNESS_YOGA_PILATES_WORDING_CZ,
    DE: MULTI_FITNESS_YOGA_PILATES_WORDING_DE,
    DK: MULTI_FITNESS_YOGA_PILATES_WORDING_DK,
    EE: MULTI_FITNESS_YOGA_PILATES_WORDING_EE,
    EN: MULTI_FITNESS_YOGA_PILATES_WORDING_EN,
    FI: MULTI_FITNESS_YOGA_PILATES_WORDING_FI,
    FR: MULTI_FITNESS_YOGA_PILATES_WORDING_FR,
    HR: MULTI_FITNESS_YOGA_PILATES_WORDING_HR,
    LT: MULTI_FITNESS_YOGA_PILATES_WORDING_LT,
    LV: MULTI_FITNESS_YOGA_PILATES_WORDING_LV,
    NO: MULTI_FITNESS_YOGA_PILATES_WORDING_NO,
    PL: MULTI_FITNESS_YOGA_PILATES_WORDING_PL,
    RO: MULTI_FITNESS_YOGA_PILATES_WORDING_RO,
    RS: MULTI_FITNESS_YOGA_PILATES_WORDING_RS,
    SE: MULTI_FITNESS_YOGA_PILATES_WORDING_SE,
    SI: MULTI_FITNESS_YOGA_PILATES_WORDING_SI,
    SK: MULTI_FITNESS_YOGA_PILATES_WORDING_SK,
  },
  multiAstrologyMeditationLove: {
    BA: MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_BA,
    BG: MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_BG,
    CZ: MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_CZ,
    DE: MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_DE,
    DK: MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_DK,
    EE: MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_EE,
    EN: MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_EN,
    FI: MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_FI,
    FR: MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_FR,
    HR: MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_HR,
    LT: MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_LT,
    LV: MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_LV,
    NO: MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_NO,
    PL: MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_PL,
    RO: MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_RO,
    SE: MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_SE,
    SI: MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_SI,
    SK: MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_SK,
  },
} as const satisfies GlobalWordingMap; // "as const" to make it an immutable object for TS

export default WORDING as GlobalWordingMap;
